import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const CheckBlogSource = {
  detectBlogUrls: function() {
    return axios.get(`${API_BASE}/blogs/urls`)
      .then(resp => resp.data)
  }
}

export default CheckBlogSource



// WEBPACK FOOTER //
// ./app/sources/CheckBlogSource.js